import React from 'react';
import '../Utilities/reset.css';
import './Link1.css';

function Link1(props) {
    return (
        <div className="home-container1">
            <section className="home-section1">
                Hello from Link1
            </section>
        </div>
    );
}

export default Link1;